// Quack ------------------------------------------------------
function Quack() {

	//Import classes
	var Container = include('createjs.Container'),
		Sprite = include('createjs.Sprite'),
		Tween = include('createjs.Tween');

	// parameters
	this.startX = app.config.GAME.QUACK.startx;
	this.startY = app.config.GAME.QUACK.starty;
	this.posX = 0;
	this.posY = 0;
	this.movement = app.config.GAME.QUACK.movement;
	this.leftX = this.startX - this.movement;
	this.rightX = this.startX + this.movement;
	this.topY = this.startY - this.movement;
	this.bottomY = this.startY + this.movement;
	
	// objects 
	this.view = new Sprite(LOADED_OBJECTS.sprsheets.endquack_spr, 'pause');
	
	this.floatQuack = this.floatQuack.bind(this);

	this.init();
}

namespace('WGBH').Quack = Quack;

var p = Quack.prototype;

// used to initialize the button
p.init = function() {
	this.view.scaleX = this.view.scaleY = app.config.GAME.QUACK.scaling;
	this.view.x = this.startX;
	this.view.y = this.startY;
	this.view.rotation = app.config.GAME.QUACK.rotation;
	// start tweening
	this.floatQuack();
};

// used to 'float' quack
p.floatQuack = function() {
	this.posX = getRandomWholeNumber(-this.movement, this.movement) + this.view.x;
	this.posY = getRandomWholeNumber(-this.movement, this.movement) + this.view.y;
	// limit boundaries
	if(this.posX < this.leftX) {
		this.posX = this.leftX;
	}	
	if(this.posX > this.rightX) {
		this.posX = this.rightX;
	}	
	if(this.posY < this.topX) {
		this.posY = this.topX;
	}	
	if(this.posY > this.bottomX) {
		this.posY = this.bottomX;
	}	
	this.float_tween = createjs.Tween.get(this.view, {override:true}).to({x:this.posX, y:this.posY}, app.config.GAME.QUACK.time).call(this.floatQuack);
};

// used to clear the object
p.clearObject = function() {
	this.float_tween.setPaused(true);
	this.view = null;
};
